import React, { useCallback, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

type CreateCollectionButtonProps = {
  collectionOrderId: string;
  disabled: boolean;
  label?: string;
  injectData?: any;
  className?: string;
  buttonVariant?: string;
};
const CreateCollectionButton = ({
  collectionOrderId,
  disabled,
  label = 'Δημιουργία Νέας Συλλογής',
  injectData = {},
  className = '',
  buttonVariant = 'outline-primary',
}: CreateCollectionButtonProps) => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleNewCollection = useCallback(
    (collectionOrderId) => {
      const navigationState = {
        collectionOrderId: collectionOrderId,
        injectData: injectData,
      };

      console.log('[CreateCollectionButton] click -> /collection/-1', {
        collectionOrderId,
        typeOf: typeof collectionOrderId,
        disabled,
        injectData,
        injectDataKeys: injectData ? Object.keys(injectData) : [],
        injectDataCollectionPointId: injectData?.collectionPointId ?? injectData?.collectionpointId,
        injectDataWasteReceptionPointId: injectData?.wastereceptionpointId,
        navigationState,
      });

      if (!collectionOrderId) return;

      history.push('/collection/-1', navigationState);
    },
    [disabled, history, injectData],
  );

  return (
    <Button
      onClick={() => handleNewCollection(collectionOrderId)}
      disabled={disabled}
      type="button"
      className={`btn d-flex align-items-center ${className}`}
      style={{
        height: '30px',
      }}
      variant={buttonVariant}
    >
      <FaPlus className="me-2" />
      {t(label)}
    </Button>
  );
};

export default CreateCollectionButton;
